<div class="login-header nes-relative" *ngIf='!isEmbedded()'>
  <div class="login-header__background nes-z-10 nes-mx-auto nes-absolute"></div>
  <nes-container>
    <nes-asset
      class="login-header__asset nes-z-20 nes-absolute"
      name="flow-gradient"
      color="blue-500"
      lazy="false"
      aria-label="Logo"
    ></nes-asset>

    <div class="login-header__text nes-absolute nes-mx-auto nes-z-30 nes-pt-10 lg:nes-pt-16">
      <nes-heading class="nes-mb-6" color="white">{{ 'LOGIN.AUTH.LOGIN' | translate }}</nes-heading>
      <nes-text color="white" class="nes-text-lg nes-mb-16">
        {{ 'LOGIN.CHOOSE_ACCOUNT.TITLE' | translate }}
        <ng-container *ngIf="'MY_NS' | translate as title"
          ><span class="no-wrap"> {{ title }}? </span>
        </ng-container>
      </nes-text>
    </div>
    <div class="nes-absolute nes-z-30 nes-w-full nes-bottom-4">
      <nes-divider type="brand"></nes-divider>
    </div>
  </nes-container>
</div>
